/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PriceUnitData
 */
export interface PriceUnitData {
    /**
     * 
     * @type {string}
     * @memberof PriceUnitData
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof PriceUnitData
     */
    name?: string;
}

/**
 * Check if a given object implements the PriceUnitData interface.
 */
export function instanceOfPriceUnitData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PriceUnitDataFromJSON(json: any): PriceUnitData {
    return PriceUnitDataFromJSONTyped(json, false);
}

export function PriceUnitDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceUnitData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function PriceUnitDataToJSON(value?: PriceUnitData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'name': value.name,
    };
}

